import { Calendar } from '@nike/nike-design-system-icons';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import Input from './Input';
import { useGetLocalization } from '../../hooks';

const CustomInput = forwardRef(
  ({ value, onClick, onChange, label, error, errorMessage, readOnly, isDisabled, id }, ref) => (
    <Input
      label={label}
      value={value}
      onClick={onClick}
      dateInputOnChange={onChange}
      error={error}
      errorMessage={errorMessage}
      readOnly={readOnly}
      TrailingIcon={<Calendar />}
      onIconClick={onClick}
      onChange={onChange}
      ref={ref}
      isDisabled={isDisabled}
      id={id || `${label}-custom-input`}
      style={{ textAlign: 'initial' }}
    />
  ),
);

CustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorMessage: PropTypes.string,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  id: PropTypes.string,
};

CustomInput.defaultProps = {
  value: '',
  onClick: () => {},
  onChange: () => {},
  label: '',
  error: false,
  errorMessage: '',
  readOnly: false,
  isDisabled: false,
  id: '',
};
function DateInput({
  errorMessage,
  isDisabled,
  isRequired,
  label,
  maxDate,
  minDate,
  onChange,
  value,
}) {
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;
    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) return null;
    const [year, month, day] = dateParts.map(Number);
    return new Date(year, month - 1, day);
  };

  const getLocalization = useGetLocalization();
  const selectedDate = value ? parseLocalDate(value) : null;
  const minDateObj = minDate ? parseLocalDate(minDate) : undefined;
  const maxDateObj = maxDate ? parseLocalDate(maxDate) : undefined;

  return (
    <DatePicker
      selected={selectedDate}
      onChange={(date) => onChange(date ? date.toISOString().slice(0, 10) : '')}
      minDate={minDateObj}
      maxDate={maxDateObj}
      disabled={isDisabled}
      placeholderText={getLocalization('lbl.calendar-icon')}
      dateFormat="yyyy-MM-dd"
      customInput={
        <CustomInput
          label={label + (isRequired ? '*' : '')}
          error={errorMessage || (isRequired && !value)}
          errorMessage={errorMessage}
          readOnly={isDisabled}
          isDisabled={isDisabled}
          onChange={onChange}
        />
      }
      autoComplete="off"
    />
  );
}

DateInput.defaultProps = {
  errorMessage: '',
  isDisabled: false,
  isRequired: false,
  maxDate: '9999-12-31',
  minDate: '0000-01-01',
  value: '',
};

DateInput.propTypes = {
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default DateInput;
